module.exports = __webpack_public_path__ + "img/img0.f844f5ad.jpg";